export default "__VITE_ASSET__BBtSdtZa__"